export const REFRESH_REDUCERS = "REFRESH_REDUCERS" as const;

export const refreshReducersToInitial = () => ({ type: REFRESH_REDUCERS } as const);